module.exports = "/assets/data/7610ef940f99dcd583a5fdcab1d98bf6-G31.data.json";